/**
 * Ryan O'Dowd
 * 2024-03-03
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({globalScale, colors}) => {
  return {
    moduleName: {
      margin: 0,
      padding: 0,
      color: colors.primaryExtraLight,
      fontSize: globalScale * 18,
    },
    editIconButton: {
      margin: 4,
      color: colors.primaryExtraLight,
    },
    editIconButtonCheck: {
      marginLeft: 8,
      color: colors.dialogText,
      backgroundColor: colors.accent,
    },
    editIconButtonClose: {
      backgroundColor: colors.alert,
    },
    dragIconWrapper: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      cursor: 'grab',
    },
    editRow: {
      display: 'flex',
      flexGrow: 1,
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '100%',
    },
    fullTitleWrapper: {
      display: 'flex',
      flexDirection: 'column',
    },
    subTitle: {
      color: colors.accent,
      fontSize: globalScale * 12,
    },
    actionsWrapper: { // @TODO: abstract with assignment styles
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      gap: 8,
    },
  };
};

export default getStyles;
